import { atom } from "recoil";

export const notificationsState = atom({
    key: "notificationsState",
    default: [],
});

export const notificationsLoadingState = atom({
    key: "notificationsLoadingState",
    default: false,
});
